import { render } from "./tableedit.vue?vue&type=template&id=08a5d8ea"
import script from "./tableedit.vue?vue&type=script&lang=js"
export * from "./tableedit.vue?vue&type=script&lang=js"

import "./tableedit.vue?vue&type=style&index=0&id=08a5d8ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__